import constants from '../../../../constants';

const STORAGE_PATH_TEMPLATE: string = constants.storagePath ?? '{0}';

function build(url: string): string {
  return STORAGE_PATH_TEMPLATE.replace('{0}', url);
}

export function resolveImagePath(url: string | null): string {
  return url ? build(url) : '';
}

export function resolveAvatarPath(url: string | null): string {
  return url ? `${build(url)}?w=200` : '';
}

export function resolveHeroPath(url: string | null): string {
  return url ? `${build(url)}?w=850&keepFormat=false` : '';
}

export function resolveAboutImagePath(url: string | null): string {
  return url ? `${build(url)}?w=850` : '';
}
